const FullMenu = {
  soups: [
    {
      id: 'S1',
      title: 'Peking Hot & Sour Soup',
      detail: 'Roast Pork & Prawns',
      priceGbp: 4.10,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S2',
      title: 'Chicken & Sweetcorn Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S3',
      title: 'Chicken & Mushroom Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S4',
      title: 'Chicken & Noodle Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S5',
      title: 'Won Ton Soup',
      detail: 'Minced Prawns',
      priceGbp: 4.30,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S6',
      title: 'Won Ton & Noodle Soup',
      detail: 'Minced Prawns',
      priceGbp: 4.30,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S7',
      title: 'Tom Yum Goong Soup',
      detail: null,
      priceGbp: 4.80,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'S8',
      title: 'Plain Sweetcorn Soup',
      detail: null,
      priceGbp: 3.40,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'S9',
      title: 'Mixed Vegetable Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'S10',
      title: 'Mixed Vegetable Hot & Sour Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'S11',
      title: 'Sweetcorn & Fresh Asparagus Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'S12',
      title: 'Tofu & Mixed Vegetable Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'S13',
      title: 'Mushroom Soup',
      detail: null,
      priceGbp: 3.30,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'S14',
      title: 'Mushroom & Noodle Soup',
      detail: null,
      priceGbp: 3.60,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
  ],
  appetisers: [
    {
      id: 'A1',
      title: 'Traditional Oven Roasted Barbecue Spare Ribs',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Syrup',
          priceGbp: 6.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Barbecue Sauce',
          priceGbp: 7.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A2',
      title: 'Deep Fried Spare Ribs',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Salt & Mixed Roasted Spices',
          priceGbp: 7.00,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 7.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 7.00,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 7.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 7.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A3',
      title: 'Chicken Wings',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Plain',
          priceGbp: 5.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Honey',
          priceGbp: 5.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Salt & Mixed Roast Spices',
          priceGbp: 5.80,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 5.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 5.80,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 5.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 5.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A4',
      title: 'King Prawns with Salt & Mixed Roasted Spices',
      detail: null,
      priceGbp: 7.60,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A5',
      title: 'King Prawn Skewers',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Satay Sauce',
          priceGbp: 7.60,
          spiceLevel: 3,
          isNutty: true,
          isVeggie: false,
        },
        {
          title: 'Teriyaki Sauce',
          priceGbp: 7.60,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A6',
      title: 'Squid with Salt & Mixed Roasted Spices',
      detail: null,
      priceGbp: 6.80,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A7',
      title: 'Chicken Skewers',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Satay Sauce',
          priceGbp: 5.80,
          spiceLevel: 3,
          isNutty: true,
          isVeggie: false,
        },
        {
          title: 'Teriyaki Sauce',
          priceGbp: 5.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A8',
      title: 'Crispy Seaweed',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Without Ground Fish',
          priceGbp: 4.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Ground Fish',
          priceGbp: 4.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A9',
      title: 'Prawn Toast (2 pieces)',
      detail: null,
      priceGbp: 4.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A10',
      title: 'Meat Spring Rolls (3)',
      detail: null,
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A11',
      title: 'Large Meat Chop Suey Rolls',
      detail: 'Please allow 15 minutes',
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A12',
      title: 'Crispy Won Tons (Minced Prawns) with Sweet & Sour Sauce',
      detail: null,
      priceGbp: 4.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A13',
      title: 'Mixed Platter for 2 (minimum of 2 people)',
      detail: null,
      priceGbp: 17.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A14',
      title: 'Aromatic Crispy Duck',
      detail: 'Served with Pancakes, Cucumber, Spring Onions & Hoi Sin Sauce',
      priceGbp: null,
      options: [
        {
          title: 'Quarter (6 Pancakes)',
          priceGbp: 11.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Half (12 Pancakes)',
          priceGbp: 21.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Whole (24 Pancakes)',
          priceGbp: 39.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Extra Hoi Sin Sauce',
          priceGbp: 1.20,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Extra Pancakes',
          priceGbp: 1.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A15',
      title: 'Vegetable Spring Rolls (3)',
      detail: null,
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'A16',
      title: 'Large Vegetarian Chop Suey Roll',
      detail: "Please allow 15 minutes",
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'A17',
      title: 'Tofu Skewers',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Black Bean Sauce',
          priceGbp: 5.40,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Satay Sauce',
          priceGbp: 5.40,
          spiceLevel: 3,
          isNutty: true,
          isVeggie: false,
        },
        {
          title: 'Teriyaki Sauce',
          priceGbp: 5.40,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'A18',
      title: 'Vegetable Won Tons',
      detail: null,
      priceGbp: 4.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'A19',
      title: 'Mock Crispy Duck',
      detail: null,
      priceGbp: 10.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'A20',
      title: 'Sweetcorn Cakes',
      detail: null,
      priceGbp: 4.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'A21',
      title: 'Salt & Pepper Mushrooms',
      detail: null,
      priceGbp: 5.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
  ],
  eggFriedRiceDishes: [
    {
      id: '1',
      title: 'Special Fried Rice (Chicken, Char Siu & Prawns)',
      detail: null,
      priceGbp: 8.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '2',
      title: 'King Prawn Fried Rice',
      detail: null,
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '3',
      title: 'Chicken Fried Rice',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '4',
      title: 'Beef Fried Rice',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '5',
      title: 'Prawn Fried Rice',
      detail: null,
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '6',
      title: 'Char Sui Fried Rice',
      detail: 'Marinated Chinese Roast Pork',
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '7',
      title: 'Roast Duck Fried Rice',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '8',
      title: 'Yeung Chow Fried Rice',
      detail: 'Char Siu & Prawns',
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '9',
      title: 'Seafood Fried Rice',
      detail: 'King Prawns, Squid & Mussels',
      priceGbp: 9.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '9A',
      title: 'Squid Fried Rice',
      detail: null,
      priceGbp: 9.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '10',
      title: 'Singapore Style Fried Rice',
      detail: 'Char Siu & Prawns',
      priceGbp: 9.00,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: false,
    },
  ],
  noodleDishes: [
    {
      id: '11',
      title: 'Special Chow Mein (Chicken, Char Siu & Prawns)',
      detail: null,
      priceGbp: 8.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '12',
      title: 'King Prawn Chow Mein',
      detail: null,
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '13',
      title: 'Chicken Chow Mein',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '14',
      title: 'Beef Chow Mein',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '15',
      title: 'Prawn Chow Mein',
      detail: null,
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '16',
      title: 'Char Siu Chow Mein',
      detail: 'Marinated Chinese Roast Pork',
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '17',
      title: 'Roast Duck Chow Mein',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '18',
      title: 'Seafood Chow Mein',
      detail: 'King Prawns, Squid & Mussels',
      priceGbp: 9.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '19',
      title: 'Singapore Style Chow Mein',
      detail: 'Char Siu & Prawns',
      priceGbp: 9.00,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '20',
      title: 'Singapore Style Vermicelli',
      detail: 'Char Siu & Prawns',
      priceGbp: 9.00,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '21',
      title: 'Ha Moon Style Vermicelli',
      detail: 'Sweet & Sour, Char Siu & Prawns',
      priceGbp: 9.00,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '22',
      title: 'Pad Thai',
      detail: 'Thai Style Fried Rice Noodles, Tangy, Contains Eggs & Nuts',
      priceGbp: null,
      options: [
        {
          title: 'A) King Prawn',
          priceGbp: 9.50,
          spiceLevel: 0,
          isNutty: true,
          isVeggie: false,
        },
        {
          title: 'B) Chicken',
          priceGbp: 8.50,
          spiceLevel: 3,
          isNutty: true,
          isVeggie: false,
        },
      ],
      spiceLevel: 1,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '23',
      title: 'Mie Goreng',
      detail: 'Malaysian Style Fried Egg Noodles',
      priceGbp: null,
      options: [
        {
          title: 'A) King Prawn',
          priceGbp: 9.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'B) Chicken',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'C) Roast Duck',
          priceGbp: 10.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 4,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '24',
      title: 'Spicy XO Udon (Japanese Style Noodles)',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'A) Seafood (King Prawns, Squid & Mussels)',
          priceGbp: 9.30,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'B) King Prawns',
          priceGbp: 9.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'C) Chicken',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'D) Roast Duck',
          priceGbp: 10.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'E) Char Siu',
          priceGbp: 8.80,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 2,
      isNutty: false,
      isVeggie: false,
    },
  ],
  sweetAndSourDishes: [
    {
      id: '25',
      title: 'Mixed in Batter',
      detail: 'Chicken, Pork & Tiger King Prawns',
      priceGbp: 9.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '26',
      title: 'Tiger King Prawns in Batter',
      detail: null,
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '27',
      title: 'Chicken in Batter (Chicken Balls)',
      detail: null,
      priceGbp: 8.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '28',
      title: 'Chicken Cantonese Style in Lemon & Lime Sauce',
      detail: null,
      priceGbp: 8.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '29',
      title: 'Crispy Chicken Cantonese Style',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Chilli & Garlic Hot Sauce',
          priceGbp: 8.50,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Salt & Mixed Roasted Spices',
          priceGbp: 8.50,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 8.50,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '30',
      title: 'Deep Fried Crispy Beef',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Chilli & Garlic Hot Sauce',
          priceGbp: 8.50,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Salt & Mixed Roasted Spices',
          priceGbp: 8.50,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 8.50,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '31',
      title: 'Crispy Pork Cantonese Style',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Chilli & Garlic Hot Sauce',
          priceGbp: 8.50,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Salt & Mixed Roasted Spices',
          priceGbp: 8.50,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 8.50,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 8.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '32',
      title: 'King Prawns Cantonese Style',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 9.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Chilli & Garlic Hot Sauce',
          priceGbp: 9.50,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Salt & Mixed Roasted Spices',
          priceGbp: 9.50,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 9.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 9.50,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 9.50,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '33',
      title: 'Mixed in Cantonese Style',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Sweet & Sour Sauce',
          priceGbp: 9.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Chilli & Garlic Hot Sauce',
          priceGbp: 9.00,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Salt & Mixed Roasted Spices',
          priceGbp: 9.00,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'OK Sauce',
          priceGbp: 9.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Kung Po Sauce',
          priceGbp: 9.00,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Peking Sauce',
          priceGbp: 9.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
  ],
  chefsSpecialDishes: [
    {
      id: 'A',
      title: 'Deep Fried Fish',
      detail: null,
      priceGbp: 9.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '34',
      title: 'Black Pepper & Garlic Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '35',
      title: 'Cashew Nuts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '36',
      title: 'Chilli & Garlic Hot Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '37',
      title: 'Mixed Vegetables with Aubergines in Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '38',
      title: 'Chinese Black Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '39',
      title: 'Chinese Straw Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '40',
      title: 'Garlic Mushrooms & Broccoli',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '41',
      title: 'Ginger & Spring Onion',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '42',
      title: 'Mixed Vegetables',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '43',
      title: 'OK Sauce (Tangy)',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '44',
      title: 'Oyster Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '45',
      title: 'Peking Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '46',
      title: 'Peppers & Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '47',
      title: 'Satay Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '48',
      title: 'Seasonal Greens',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '49',
      title: 'Sichuan Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 4,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '50',
      title: 'Teriyaki Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '51',
      title: 'Thai Curry',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '52',
      title: 'Char Siu Cantonese Style',
      detail: 'Please allow a minimum of 15 minutes',
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '53',
      title: 'Char Siu in Plum Sauce',
      detail: 'Please allow a minimum of 15 minutes',
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '54',
      title: 'Char Siu in Peking Sauce',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '55',
      title: 'Char Siu in Teriyaki Sauce',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '56',
      title: 'Chicken in Teriyaki Sauce',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '57',
      title: 'Deep Fried Fish in Lemon Sauce',
      detail: null,
      priceGbp: 9.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '58',
      title: 'Roast Duck Cantonese Style',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '59',
      title: 'Roast Duck in Lemon Sauce',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '60',
      title: 'Roast Duck in Orange Sauce',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '61',
      title: 'Roast Duck in Plum Sauce',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
  ],
  mainDishes: [
    {
      id: 'A',
      title: 'Special (Chicken, Char Siu & Prawns)',
      detail: null,
      priceGbp: 8.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'B',
      title: 'King Prawns',
      detail: null,
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'C',
      title: 'Chicken',
      detail: null,
      priceGbp: 8.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'D',
      title: 'Beef',
      detail: null,
      priceGbp: 8.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'E',
      title: 'Prawns',
      detail: null,
      priceGbp: 8.60,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'F',
      title: 'Char Siu (Marinated Chinese Roast Pork)',
      detail: null,
      priceGbp: 8.60,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'G',
      title: 'Mixed Seafood (King Prawns, Squid & Mussels)',
      detail: null,
      priceGbp: 9.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'H',
      title: 'Roast Duck',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '62',
      title: 'Bamboo Shoots & Water Chestnuts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '63',
      title: 'Beansprouts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '64',
      title: 'Chop Suey (Mixed Vegetables)',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '65',
      title: 'Curry Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '66',
      title: 'Foo Yung (Scrambled Egg)',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '67',
      title: 'Fresh Tomato',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '68',
      title: 'Mixed Vegetables',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '69',
      title: 'Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '70',
      title: 'Pineapple (with or without young ginger)',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
  ],
  extraordinaryDishes: [
    {
      id: 'A',
      title: 'Special (Chicken, Char Siu & Prawns)',
      detail: null,
      priceGbp: 8.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'B',
      title: 'King Prawns',
      detail: null,
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'C',
      title: 'Chicken',
      detail: null,
      priceGbp: 8.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'D',
      title: 'Beef',
      detail: null,
      priceGbp: 8.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'E',
      title: 'Prawns',
      detail: null,
      priceGbp: 8.60,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'F',
      title: 'Char Siu (Marinated Chinese Roast Pork)',
      detail: null,
      priceGbp: 8.60,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'G',
      title: 'Mixed Seafood (King Prawns, Squid & Mussels)',
      detail: null,
      priceGbp: 9.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: 'H',
      title: 'Roast Duck',
      detail: null,
      priceGbp: 10.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '71',
      title: 'Baby Sweetcorn',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '72',
      title: 'Black Pepper & Garlic Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '73',
      title: 'Cashew Nuts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '74',
      title: 'Chinese Black Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '75',
      title: 'Chinese Straw Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '76',
      title: 'Garlic Mushrooms & Broccoli',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '77',
      title: 'Ginger & Spring Onion',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '78',
      title: 'Kung Po Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '78A',
      title: 'Mixed Vegetables with Aubergines & Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '79',
      title: 'OK Sauce (Tangy)',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '80',
      title: 'Oyster Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '81',
      title: 'Peppers & Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '82',
      title: 'Satay sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: '83',
      title: 'Seasonal Greens',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '84',
      title: 'Sichuan Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 4,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '85',
      title: 'Thai Curry',
      detail: "Please allow 15 minutes",
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: false,
    },
  ],
  vegetarianRiceAndNoodleDishes: [
    {
      id: '86',
      title: 'Mixed Vegetable Fried Rice',
      detail: 'Contains Egg',
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '87',
      title: 'Mixed Vegetable Singapore Style Fried Rice ',
      detail: 'Contains Egg',
      priceGbp: 8.70,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '88',
      title: 'Mixed Vegetable Chow Mein',
      detail: null,
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '88A',
      title: 'Aubergine (Eggplant) Chow Mein',
      detail: null,
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '88B',
      title: 'Broccoli Chow Mein',
      detail: null,
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '89',
      title: 'Mixed Vegetable Singapore Style Chow Mein',
      detail: null,
      priceGbp: 8.70,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '90',
      title: 'Mixed Vegetable Singapore Vermicelli',
      detail: null,
      priceGbp: 8.70,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '91',
      title: 'Mixed Vegetable Ha Moon Vermicelli',
      detail: null,
      priceGbp: 8.70,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '92',
      title: 'Mixed Vegetable Pad Thai',
      detail: 'Contains Egg',
      priceGbp: 8.70,
      options: null,
      spiceLevel: 1,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '93',
      title: 'Mock Chicken or Mock Duck Chow Mein',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '94',
      title: 'Mock Chicken or Mock Duck Singapore Style Chow Mein',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '95',
      title: 'Mock Chicken or Mock Duck Singapore Style Vermicelli',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '96',
      title: 'Mock Chicken or Mock Duck Ha Moon Style Vermicelli',
      detail: 'Sweet & Sour',
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '97',
      title: 'Mock Chicken or Mock Duck Pad Thai',
      detail: 'Contains Egg',
      priceGbp: 9.10,
      options: null,
      spiceLevel: 1,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '98',
      title: 'Mushroom Fried Rice',
      detail: 'Contains Egg',
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '99',
      title: 'Mushroom Chow Mein',
      detail: null,
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '100',
      title: 'Tofu Chow Mein',
      detail: null,
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '101',
      title: 'Tofu Ha Moon Style Vermicelli',
      detail: 'Sweet & Sour',
      priceGbp: 8.70,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '102',
      title: 'Tofu Pad Thai',
      detail: 'Contains Egg',
      priceGbp: 8.70,
      options: null,
      spiceLevel: 1,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '103',
      title: 'Tofu Singapore Style Chow Mein',
      detail: null,
      priceGbp: 8.70,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '104',
      title: 'Tofu Singapore Style Vermicelli',
      detail: null,
      priceGbp: 8.70,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
  ],
  chefsSpecialVegetarianDishes: [
    {
      id: 'A',
      title: 'Mock Chicken',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: 'B',
      title: 'Mock Duck',
      detail: null,
      priceGbp: 9.10,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '105',
      title: 'Baby Sweetcorn',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '106',
      title: 'Bamboo Shoots & Water Chestnuts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '107',
      title: 'Beansprouts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '108',
      title: 'Black Pepper & Garlic Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '109',
      title: 'Cashew Nuts',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '110',
      title: 'Chilli & Garlic Hot Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '111',
      title: 'Chinese Black Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '112',
      title: 'Chinese Straw Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '113',
      title: 'Curry Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '114',
      title: 'Fresh Tomatoes',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '115',
      title: 'Garlic Mushrooms & Broccoli',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '116',
      title: 'Ginger & Spring Onion',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '117',
      title: 'Kung Po Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '118',
      title: 'Lemon Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '119',
      title: 'Mixed Vegetables',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '118A',
      title: 'Mixed Vegetables with Aubergines & Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '120',
      title: 'Mushrooms',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '121',
      title: 'OK Sauce (Tangy)',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '122',
      title: 'Orange Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '123',
      title: 'Oyster Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '124',
      title: 'Peking Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '125',
      title: 'Peppers & Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '126',
      title: 'Plum Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '127',
      title: 'Salt & Mixed Roasted Spices',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '128',
      title: 'Satay Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '129',
      title: 'Seasonal Greens',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '130',
      title: 'Sichuan Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 4,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '131',
      title: 'Sweet & Sour Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '132',
      title: 'Teriyaki Sauce',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '133',
      title: 'Thai Curry',
      detail: null,
      priceGbp: null,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
  ],
  mixedVegetableOrMushroomDishes: [
    {
      id: '134',
      title: 'Bamboo Shoots & Water Chestnuts',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '135',
      title: 'Baby Sweetcorn',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '136',
      title: 'Black Pepper & Garlic Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '137',
      title: 'Cashew Nuts',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '138',
      title: 'Chinese Black Mushrooms',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '139',
      title: 'Chinese Straw Mushrooms',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '140',
      title: 'Chop Suey',
      detail: 'Mixed Vegetables',
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '141',
      title: 'Curry Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '142',
      title: 'Foo Yung',
      detail: 'Scrambled Egg',
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '143',
      title: 'Fresh Tomatoes',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '144',
      title: 'Garlic Mushrooms & Broccoli',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '145',
      title: 'Ginger & Spring Onions',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '146',
      title: 'Kung Po Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '146A',
      title: 'Mixed Veg With Aubergines & Black Bean Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '147',
      title: 'Omelette',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '148',
      title: 'OK Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '149',
      title: 'Oyster Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '150',
      title: 'Peppers & Black Bean Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '151',
      title: 'Satay Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '152',
      title: 'Seasonal Greens',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '153',
      title: 'Sichuan Sauce',
      detail: null,
      priceGbp: 7.80,
      options: null,
      spiceLevel: 4,
      isNutty: false,
      isVeggie: true,
    },
  ],
  tofuDishes: [
    {
      id: '154',
      title: 'Bamboo Shoots & Water Chestnuts',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '155',
      title: 'Bamboo Shoots, Water Chestnuts & Chinese Black Mushrooms',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '156',
      title: 'Baby Sweetcorn',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '157',
      title: 'Black Pepper & Garlic Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '158',
      title: 'Chop Suey (Mixed Vegetables)',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '159',
      title: 'Curry Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '160',
      title: 'Chilli & Garlic Hot Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '161',
      title: 'Chinese Black Mushrooms',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '162',
      title: 'Chinese Straw Mushrooms',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '163',
      title: 'Fresh Tomatoes',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '164',
      title: 'Garlic Mushrooms & Broccoli',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '165',
      title: 'Ginger & Spring Onions',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '166',
      title: 'Kung Po Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '167',
      title: 'Mixed Vegetables',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '168',
      title: 'Mixed Vegetables with Aubergines (Eggplant) in Black Bean Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '169',
      title: 'Mixed Vegetables with Cashew Nuts',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '170',
      title: 'Mushrooms',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '171',
      title: 'OK Sauce (Tangy)',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '172',
      title: 'Peppers & Black Bean Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '173',
      title: 'Peking Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '174',
      title: 'Pineapple (with or without young ginger)',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '175',
      title: 'Salt & Mixed Roasted Spices',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '176',
      title: 'Satay Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: '177',
      title: 'Seasonal Greens',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '178',
      title: 'Sichuan Sauce',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 4,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '179',
      title: 'Sweet & Sour',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: '180',
      title: 'Thai Curry',
      detail: null,
      priceGbp: 8.00,
      options: null,
      spiceLevel: 2,
      isNutty: true,
      isVeggie: true,
    },
  ],
  alternativeDishes: [
    {
      id: '181',
      title: 'Chicken Omelette',
      detail: null,
      priceGbp: 7.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '182',
      title: 'King Prawn Omelette',
      detail: null,
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '183',
      title: 'King Prawns in Batter',
      detail: 'served with Lemon Wedges',
      priceGbp: 9.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '184',
      title: 'Prawn Omelette',
      detail: null,
      priceGbp: 8.20,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '185',
      title: 'Roast Chicken Quarter (with Peas & Gravy)',
      detail: null,
      priceGbp: 7.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: '186',
      title: 'Sausages (with Peas & Onion Gravy)',
      detail: null,
      priceGbp: 7.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
  ],
  sides: [
    {
      id: null,
      title: 'Chips',
      detail: null,
      priceGbp: 2.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Boiled Rice',
      detail: null,
      priceGbp: 3.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Egg Fried Rice',
      detail: null,
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Chow Mein (Soft Noodles)',
      detail: null,
      priceGbp: 3.70,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Vermicelli (in Soy Sauce)',
      detail: null,
      priceGbp: 4.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Salt & Pepper Chips',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 3.50,
          spiceLevel: 1,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 4.20,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: '1/2 Boiled Rice 1/2 Chips',
      detail: null,
      priceGbp: 3.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: '1/2 Egg Fried Rice 1/2 Chips',
      detail: null,
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Bamboo Shoots & Water Chestnuts',
      detail: null,
      priceGbp: 3.60,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Beansprouts',
      detail: null,
      priceGbp: 3.60,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Fried Onions',
      detail: null,
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Mushrooms',
      detail: null,
      priceGbp: 3.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Salt & Pepper Mushrooms',
      detail: null,
      priceGbp: 5.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Mixed Vegetables',
      detail: null,
      priceGbp: 5.30,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Seasonal Greens',
      detail: null,
      priceGbp: 6.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Roast Chicken (Quarter)',
      detail: 'Please allow 15 minutes',
      priceGbp: 4.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Sausage',
      detail: null,
      priceGbp: 2.00,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Chilli Oil',
      detail: null,
      priceGbp: 1.00,
      options: null,
      spiceLevel: 3,
      isNutty: true,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Soy Sauce',
      detail: null,
      priceGbp: 0.80,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Sweet Chilli Sauce',
      detail: null,
      priceGbp: 1.00,
      options: null,
      spiceLevel: 1,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Prawn Crackers',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 1.90,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Large',
          priceGbp: 2.60,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Curry Sauce',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Sweet & Sour Sauce',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Gravy',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Barbeque Sauce',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: false,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Black Bean Sauce',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 2,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 2,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Kung Po Sauce',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 3,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
    {
      id: null,
      title: 'OK Sauce (Tangy)',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 0,
          isNutty: false,
          isVeggie: true,
        },
      ],
      spiceLevel: 0,
      isNutty: false,
      isVeggie: true,
    },
    {
      id: null,
      title: 'Satay Sauce',
      detail: null,
      priceGbp: null,
      options: [
        {
          title: 'Small',
          priceGbp: 2.00,
          spiceLevel: 3,
          isNutty: true,
          isVeggie: true,
        },
        {
          title: 'Large',
          priceGbp: 2.30,
          spiceLevel: 3,
          isNutty: true,
          isVeggie: true,
        },
      ],
      spiceLevel: 3,
      isNutty: true,
      isVeggie: true,
    },
  ],
  drinks: [
    {
      id: null,
      title: 'Coke, Fanta, 7up, Diet Coke, Tango, Pepsi',
      detail: null,
      priceGbp: 0.90,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
    {
      id: null,
      title: 'Aloe Vera Juice, Iced Lemon Tea, Cane Sugar Drink, Coconut Juice, Green Tea',
      detail: null,
      priceGbp: 1.50,
      options: null,
      spiceLevel: 0,
      isNutty: false,
      isVeggie: false,
    },
  ],
};

export default FullMenu;
